import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';

const SplitButton = observer(class SplitButton extends React.Component {
    constructor() {
        super();
        this.toggleOptions = this.toggleOptions.bind(this);
    }

    componentWillMount() {
        this.state = {
            showing: false
        };
    }

    toggleOptions(e) {
        this.setState({
            showing: !this.state.showing
        });
    }

    render() {
        const { options, text, onClick, translation } = this.props;

        return (
            <div
                className={`split-btn ${!this.props.options ? 'split-btn--empty' : ''}`}
            >
                <button
                    className="split-btn__link cover"
                    onClick={onClick}
                >
                    {text}
                </button>
                <span
                    className="split-btn__text"
                    aria-hidden="true"
                >
                    {text}
                </span>

                {this.props.options &&
                <Dropdown
                    className="split_dropdown"
                    ref="splitButton"
                    onShow={this.toggleOptions}
                    onHide={this.toggleOptions}
                >
                    <DropdownTrigger
                        className="split-btn__trigger"
                    >
                        <span className="meta">{translation.dropdown}</span>
                    </DropdownTrigger>

                    <DropdownContent>
                        <ul className="dropdown__menu">
                            {options.map(
                                (key, i) =>
                                    <li key={i}>
                                        <button
                                            className="dropdown__item_split split-btn__option"
                                            onClick={key.onClick}
                                        >
                                            {key.title}
                                        </button>
                                    </li>
                            )}
                        </ul>
                    </DropdownContent>
                </Dropdown>
                }
            </div>
        )
    }
})

export default translate('SplitButton')(SplitButton);



// WEBPACK FOOTER //
// ./src/app/components/Common/SplitButton.js